import styled from "@emotion/styled";

export const CardContainer = styled.a`
  width: 250px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: start;
  padding: 30px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
  text-decoration: none;
  transition: box-shadow 0.3s;

  ${({ disabled }: { disabled?: boolean }) =>
    disabled
      ? `
  opacity: 0.3;
  pointer-events: none;
`
      : `&:hover {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 6px 12px;
  cursor: pointer;
}
`}
`;

export const FlexColumn = styled.div`
  display: "flex";
  flex-direction: "column";
`;

export const SystemImage = styled.img`
  height: 110px;
`;
